import { isNumber } from './runtime-values.js';
import type { DataFeature } from './data-layer.js';
import { detectTabularColumns } from './tabular-import.js';

type PointCoordinateFields = Partial<NonNullable<DataFeature['coordinateFields']>>;

export function pointCoordinateFields(feature: DataFeature): PointCoordinateFields {
  if (feature.geometry?.type !== 'Point') return {};
  if (feature.coordinateFields) return feature.coordinateFields;
  const keys = Object.keys(feature.properties);
  const mapping = detectTabularColumns(keys);
  return {
    latitude: mapping.latitude === null ? undefined : keys[mapping.latitude],
    longitude: mapping.longitude === null ? undefined : keys[mapping.longitude],
  };
}

export function syncPointCoordinateFields(feature: DataFeature): void {
  if (feature.geometry?.type !== 'Point') return;
  const fields = pointCoordinateFields(feature);
  for (const [key, value] of [[fields.latitude, feature.geometry.coordinates[1]], [fields.longitude, feature.geometry.coordinates[0]]] as const) {
    if (key) feature.properties[key] = isNumber(feature.properties[key]) ? Number(value) : String(value);
  }
}
